import { render, staticRenderFns } from "./BetsBox.vue?vue&type=template&id=289de654&scoped=true"
import script from "./BetsBox.vue?vue&type=script&lang=js"
export * from "./BetsBox.vue?vue&type=script&lang=js"
import style0 from "./BetsBox.vue?vue&type=style&index=0&id=289de654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289de654",
  null
  
)

export default component.exports